import { Cat, Dog, Rabbit, Bird, Fish, Turtle, PawPrint, type LucideIcon } from 'lucide-react';

export function petSpeciesIcon(species: string): LucideIcon {
  switch (species.toLowerCase()) {
    case 'cat': return Cat;
    case 'dog': return Dog;
    case 'rabbit': return Rabbit;
    case 'bird': return Bird;
    case 'fish': return Fish;
    case 'hamster': return PawPrint;
    case 'reptile': return Turtle;
    default: return PawPrint;
  }
}

// SVG path data for each species — used in contexts where React rendering isn't available (e.g. Leaflet HTML strings)
const SPECIES_SVG_PATHS: Record<string, string> = {
  cat: '<path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/><path d="M8 14v.5"/><path d="M16 14v.5"/><path d="M11.25 16.25h1.5L12 17l-.75-.75Z"/>',
  dog: '<path d="M11.25 16.25h1.5L12 17l-.75-.75Z"/><path d="M4.75 13.5A7.5 7.5 0 0 0 12 21a7.5 7.5 0 0 0 7.5-7.5c0-3-1.8-5.5-4.08-6.84l-.42-.16c-.7-.28-1.5-.5-2-.5s-1.3.22-2 .5l-.42.16C8.3 8 4.75 10.5 4.75 13.5Z"/><path d="M12.5 5h-.5c-1 0-2 .4-3 1l-2-3C8 2 9 1 10 1c1 0 2 .5 2 .5S13 1 14 1c1 0 2 1 3 2l-2 3c-1-.6-2-1-3-1Z"/>',
  rabbit: '<path d="M18 4a3 3 0 0 0-3 3"/><path d="M9 7a3 3 0 0 0-3-3"/><path d="M14 7h-4"/><path d="M4 15a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5c0-3.31-2.69-6-6-6h-4c-3.31 0-6 2.69-6 6z"/><path d="M9 18h6"/>',
  bird: '<path d="M16 7h.01"/><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"/><path d="m20 7 2 .5-2 .5"/><path d="M10 18v3"/><path d="M14 17.75V21"/><path d="M7 18a6 6 0 0 0 3.84-10.61"/>',
  fish: '<path d="M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z"/><path d="M18 12v.5"/><path d="M16 17.93a9.77 9.77 0 0 1 0-11.86"/><path d="M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 3.98-.23 7.9 2.27 10.5z"/><path d="M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4"/>',
};

const DEFAULT_SVG_PATH = '<circle cx="11" cy="4" r="2"/><path d="M5 22v-5l-1-1v-4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4l-1 1v5"/><path d="M8 10v12"/><path d="M15 22v-4h2a2 2 0 0 0 0-4h-3"/>';

export function petSpeciesSvgString(species: string, size = 16, color = 'white'): string {
  const paths = SPECIES_SVG_PATHS[species.toLowerCase()] ?? DEFAULT_SVG_PATH;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
}

export const KNOWN_SPECIES = [
  'cat',
  'dog',
  'rabbit',
  'bird',
  'fish',
  'hamster',
  'reptile',
  'other',
] as const;
